/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from "@material-ui/core";
import { ExitToApp, Settings } from "@material-ui/icons";
import objectPath from "object-path";
import { shallowEqual, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { getUserMessageSubscriptions, updateUserMessageSubscriptions } from "../../../../../api/message";
import { ROLES } from "../../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../../utils/logger";

// TO MODIFY auth

export function UserProfileDropdown() {
  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const [preferencesOpen, setPreferencesOpen] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
  const [savingSubscriptions, setSavingSubscriptions] = useState(false);
  const canManageMessages =
    loggedUser?.role?.rango === ROLES.SUPER_ADMIN ||
    loggedUser?.role?.rango === ROLES.ADMIN;

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  useEffect(() => {
    if (!preferencesOpen || !canManageMessages) return;
    setLoadingSubscriptions(true);
    getUserMessageSubscriptions(loggedUser.accessToken)
      .then((response) => {
        if (response.status === 200) setSubscriptions(response.data || []);
      })
      .catch((error) => alertError({ error, customMessage: "No se han podido cargar las preferencias de mensajería." }))
      .finally(() => setLoadingSubscriptions(false));
  }, [canManageMessages, loggedUser?.accessToken, preferencesOpen]);

  const saveSubscriptions = () => {
    setSavingSubscriptions(true);
    updateUserMessageSubscriptions(subscriptions, loggedUser.accessToken)
      .then(() => {
        alertSuccess({ customMessage: "Preferencias de mensajería guardadas." });
        setPreferencesOpen(false);
      })
      .catch((error) => alertError({ error, customMessage: "No se han podido guardar las preferencias de mensajería." }))
      .finally(() => setSavingSubscriptions(false));
  };

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
          }
        >
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
            Hola,
          </span>{" "}
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {loggedUser?.nombre}
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <>
          {layoutProps.light && (
            <>
              <div className="d-flex align-items-center p-8 rounded-top">
                <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                  <img src={toAbsoluteUrl("/media/users/300_21.jpg")} alt="" />
                </div>
                <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                  {loggedUser?.nombre}
                </div>
              </div>
              <div className="separator separator-solid"></div>
            </>
          )}

          {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/misc/bg-1.jpg"
                )})`,
              }}
            >
              <div className="symbol bg-white-o-15 mr-3">
                <span className="symbol-label text-success font-weight-bold font-size-h4">
                  {/* {loggedUser?.nombre[0]} */}
                </span>
              </div>
              <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
                {loggedUser?.nombre}
              </div>
            </div>
          )}
        </>

        <div className="navi navi-spacer-x-0" /* pt-5 */>
          <button type="button" className="navi-item border-0 bg-transparent w-100 text-left" onClick={() => setPreferencesOpen(true)}>
            <span className="navi-link">
              <span className="navi-icon"><Settings /></span>
              <span className="navi-text">Preferencias</span>
            </span>
          </button>
          <div className="navi-separator" /* mt-3 */></div>

          <div className="navi-footer  px-8 py-5">
            <Link
              to="/logout"
              className="btn btn-light-primary font-weight-bold"
            >
              <div className="d-flex justify-content-center align-items-center">
                Sign Out
                <ExitToApp className="ml-3" />
              </div>
            </Link>
            {/* <a href="#" className="btn btn-clean font-weight-bold">
              Upgrade Plan
						</a> */}
          </div>
        </div>
      </Dropdown.Menu>
      <Dialog open={preferencesOpen} onClose={() => !savingSubscriptions && setPreferencesOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Preferencias</DialogTitle>
        <DialogContent>
          <div className="d-flex border-bottom mb-5" style={{ gap: "1.5rem" }}>
            <button type="button" className="border-0 bg-transparent font-weight-bolder pb-3" style={{ color: "#321ACB", borderBottom: "2px solid #321ACB" }}>Mensajería</button>
          </div>
          {!canManageMessages ? (
            <div className="text-muted">Tu usuario no recibe mensajes administrativos.</div>
          ) : loadingSubscriptions ? (
            <div className="text-muted">Cargando preferencias...</div>
          ) : (
            <>
              <div className="text-muted mb-4">Elige los tipos de mensaje importante que quieres recibir.</div>
              {subscriptions.map((subscription) => (
                <FormControlLabel
                  key={subscription.tipo_evento}
                  className="d-flex border rounded px-3 py-2 mb-2 mx-0"
                  control={<Checkbox color="primary" checked={!!subscription.activo} onChange={(event) => setSubscriptions((current) => current.map((item) => item.tipo_evento === subscription.tipo_evento ? { ...item, activo: event.target.checked } : item))} />}
                  label={subscription.nombre}
                />
              ))}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreferencesOpen(false)} disabled={savingSubscriptions}>Cerrar</Button>
          {canManageMessages && <Button color="primary" variant="contained" onClick={saveSubscriptions} disabled={loadingSubscriptions || savingSubscriptions}>{savingSubscriptions ? "Guardando..." : "Guardar"}</Button>}
        </DialogActions>
      </Dialog>
    </Dropdown>
  );
}
